import dispatcher from "../dispatcher";
import { creditorConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createCreditor(creditor) {
    rq.postJson("/api/v1/creditor", creditor).then((data) => {
        creditor.creditorId = data[0].lastId;
        dispatcher.dispatch({ type: creditorConstant.CREDITOR_CREATED, creditor });
    }).catch((data) => {
        dispatcher.dispatch({ type: creditorConstant.CREDITOR_CREATION_FAILED, msg: `creating creditor ${creditor.propritorName} failed ! ${data.responseText}` });
    });
}
export function upDateCreditor(data) {
    rq.putJson("/api/v1/creditor", data).then((data) => {
        dispatcher.dispatch({ type: creditorConstant.UPDATE_CREDITOR, data });
    }).catch((err) => {
        // console.log("i am in rq fail", data);
        dispatcher.dispatch({ type: creditorConstant.UPDATE_CREDITOR_CREATION_FAILED, msg: err.msg });
    });
}


// WEBPACK FOOTER //
// ./src/jsx/actions/creditor-action.jsx